export enum VasPeriod {
    WEEK = 7,
    TWO_WEEKS = 14,
    MONTH = 30
}
